module.exports = __webpack_public_path__ + "static/media/icon-checkbox.6ff75c6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-checkbox.svg
// module id = 1261
// module chunks = 19